var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"layout-container pa-0"},[_c('ContractSettings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }